export function convertDate(date: string): Date | null {
    if (date == null || date === "") return null;
    const match = /^(\d{4})-(\d{2})-(\d{2})\s(\d{2}):(\d{2}):(\d{2})$/.exec(date);
    if (match === null) return null;
    return new Date(+match[1], +match[2] - 1, +match[3], +match[4], +match[5], +match[6]);
}
